import Badge from '@mui/material/Badge'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import React, { useCallback } from 'react'
import { Link } from 'react-router-dom-v5-compat'

import { createFavoriteUrlButton } from 'components/common/side-nav/createFavoriteUrlButton'
import { selectNotificationFavoriteUrl, setFavoriteUrl } from 'slices/notification-center/notificationDrawerSlice'

import { viewUrl, type NotificationView } from './notificationCenterViews'

type NotificationViewItemProps = {
  view: NotificationView
  unreadCount: number
  activeViewKey: string
  onSelectView: (viewKey: string) => void
}

const NotificationFavButton = createFavoriteUrlButton({
  selectFavoriteUrl: selectNotificationFavoriteUrl,
  setFavoriteUrl,
})

const NotificationViewItem = ({ view, unreadCount, activeViewKey, onSelectView }: NotificationViewItemProps) => {
  // Only the Inbox views carry a badge, and both mean the same server count.
  const badgeCount = view.showBadge ? unreadCount : 0

  const handleClick = useCallback(() => onSelectView(view.key), [onSelectView, view.key])

  return (
    <ListItem disablePadding secondaryAction={<NotificationFavButton url={viewUrl(view.key)} />}>
      {/* A real anchor, so modifier-click opens the view in a tab; the click handler only resets state. */}
      <ListItemButton component={Link} selected={view.key === activeViewKey} sx={{ pl: 4 }} to={viewUrl(view.key)} onClick={handleClick}>
        <ListItemText primary={view.title} slotProps={{ primary: { variant: 'h6', fontWeight: 400 } }} />
        {badgeCount > 0 && <Badge badgeContent={badgeCount} color="primary" sx={{ mr: 3 }} />}
      </ListItemButton>
    </ListItem>
  )
}

export default NotificationViewItem
